export default __webpack_public_path__ + "static/media/not-found.941fce00.jpeg";